export const state = () => ({
  siteNavClicked: {},
})

export const mutations = {
  SITE_NAVIGATION_CLICKED_PAYLOAD(state, payload) {
    state.siteNavClicked = payload || {}
  },
  RESET_SITE_NAVIGATION_CLICKED_PAYLOAD(state) {
    state.siteNavClicked = {}
  },
}

export const actions = {
  siteNavigationClicked({ commit }, payload) {
    commit('SITE_NAVIGATION_CLICKED_PAYLOAD', payload)
  },
  resetSiteNavigationClicked({ commit }) {
    commit('RESET_SITE_NAVIGATION_CLICKED_PAYLOAD')
  },
}

export const getters = {
  siteNavigationClickedPayload(state) {
    return state.siteNavClicked
  },
}

export default {
  getters,
  state,
  mutations,
  actions,
}
